module.exports = __webpack_public_path__ + "static/media/white_search_icon.55408aac.svg";